/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DatasetPipelineStatus } from './DatasetPipelineStatus';
import {
  DatasetPipelineStatusFromJSON,
  DatasetPipelineStatusFromJSONTyped,
  DatasetPipelineStatusToJSON,
} from './DatasetPipelineStatus';

/**
 *
 * @export
 * @interface DatasetPipelineShallow
 */
export interface DatasetPipelineShallow {
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineShallow
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof DatasetPipelineShallow
   */
  taskName?: string | null;
  /**
   *
   * @type {DatasetPipelineStatus}
   * @memberof DatasetPipelineShallow
   */
  status?: DatasetPipelineStatus | null;
}

/**
 * Check if a given object implements the DatasetPipelineShallow interface.
 */
export function instanceOfDatasetPipelineShallow(value: object): value is DatasetPipelineShallow {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function DatasetPipelineShallowFromJSON(json: any): DatasetPipelineShallow {
  return DatasetPipelineShallowFromJSONTyped(json, false);
}

export function DatasetPipelineShallowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetPipelineShallow {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    taskName: json['task_name'] == null ? undefined : json['task_name'],
    status: json['status'] == null ? undefined : DatasetPipelineStatusFromJSON(json['status']),
  };
}

export function DatasetPipelineShallowToJSON(value?: Omit<DatasetPipelineShallow, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    task_name: value['taskName'],
    status: DatasetPipelineStatusToJSON(value['status']),
  };
}
